import {
  SET_CREATING_NODE,
  SET_CURRENT_ITEM,
  SET_DARK_MODE_ENABLED,
  SET_DETAIL_POPUP,
  SET_DISABLED_RELATIONS,
  SET_DISABLED_TYPES,
  SET_EDITING_NODE,
  SET_ENABLE_NAMESPACES,
  SET_MACROS,
  SET_MEMBER_KEYS,
  SET_NAMESPACES,
  SET_NAME_KEYS,
  SET_NODE_FORM_INITIAL_VALUES,
  SET_OPEN_IN_CONSOLE,
  SET_RELATION_LABELS,
  SET_RELATION_SIZE_PARAM,
  SET_NODE_SIZE_PARAM,
  SET_TAB,
  SET_TABLE_CONFIG,
  SET_TAB_DISABLED,
  SET_TYPES_MAP,
  SET_WINDOW_DIMS,
  TOGGLE_SEARCH_MODAL
  TOGGLE_TAB_IS_LOCKED
  SET_HIDE_CHANGELOG
} from './actionTypes'

export setCurrentItem = (payload) ->
  type: SET_CURRENT_ITEM
  payload:
    data: payload

export setDarkModeEnabled = (data) ->
  type: SET_DARK_MODE_ENABLED
  payload: { data }

export setDisabledRelations = (data) ->
  type: SET_DISABLED_RELATIONS
  payload: { data }

export setDisabledTypes = (data) ->
  type: SET_DISABLED_TYPES
  payload: { data }

setTabInRedux = (payload) ->
  type: SET_TAB
  payload:
    data: payload

export setTabDisabled = (payload) ->
  type: SET_TAB_DISABLED
  payload:
    data: payload

export toggleTabLocked = ->
  { type: TOGGLE_TAB_IS_LOCKED }

export setTab = (key) ->
  setTabInRedux(key)

export setDetailPopup = (key) ->
  type: SET_DETAIL_POPUP
  payload:
    data: key

export setTableConfig = (conf) ->
  type: SET_TABLE_CONFIG
  payload:
    data: conf

export setWindowDims = (w, h) ->
  type: SET_WINDOW_DIMS
  payload:
    data: [w, h]

export setCreatingNode = (bool) ->
  type: SET_CREATING_NODE
  payload:
    data: bool

export setEditingNode = (data) ->
  type: SET_EDITING_NODE
  payload:
    data: data

export toggleSearchModal = (bool) ->
  type: TOGGLE_SEARCH_MODAL
  payload:
    data: bool

export setMacros = (data) ->
  type: SET_MACROS
  payload: { data }

export setMemberKeys = (data) ->
  type: SET_MEMBER_KEYS
  payload: { data }

export setNameKeys = (data) ->
  type: SET_NAME_KEYS
  payload: { data }

export setNamespaces = (data) ->
  type: SET_NAMESPACES
  payload: { data }

export setNamespacesEnabled = (data) ->
  type: SET_ENABLE_NAMESPACES
  payload: { data }

export setOpenInConsole = (data) ->
  type: SET_OPEN_IN_CONSOLE
  payload: { data }

export setRelationLabels = (data) ->
  type: SET_RELATION_LABELS
  payload: { data }

export setRelationSizeParam = (data) ->
  type: SET_RELATION_SIZE_PARAM
  payload: { data }

export setNodeFormInitialValues = (data) ->
  type: SET_NODE_FORM_INITIAL_VALUES
  payload: { data }

export setNodeSizeParam = (data) ->
  type: SET_NODE_SIZE_PARAM
  payload: { data }

export setTypesMap = (data) ->
  type: SET_TYPES_MAP
  payload: { data }

export setHideChangelog = (data) ->
  type: SET_HIDE_CHANGELOG
  payload: { data }
